import { ChangeEvent } from "react";
import { FormControlModel } from "types";
import Select from "./Select";
import { useField } from "formik";
import get from "lodash/get";

const SelectForm = ({
  questionData,
  name,
  label,
  formik,
  onChangeCallback,
  disabled,
  visible = true,
}: FormControlModel) => {
  const [field, meta] = useField(name);

  if (!questionData) return <></>;
  return visible ? (
    <Select
      key={name}
      id={questionData?.id}
      name={name}
      mapKey='value'
      margin='normal'
      label={label}
      disabled={disabled}
      mapValue='descripcion'
      dataSource={questionData?.source || []}
      value={formik.values[name]?.value || ""}
      onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
        const value = target?.value;
        formik.setFieldValue(name, {
          value,
          questionID: questionData?.id,
        });
        if (onChangeCallback && typeof onChangeCallback === "function") {
          onChangeCallback(value);
        }
      }}
      error={meta.touched && Boolean(get(meta.error, "value"))}
      helperText={meta.touched && get(meta.error, "value")}
    />
  ) : null;
};

export default SelectForm;
